import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-ueditor-config',
  templateUrl: './d-ueditor-config.component.html',
  styles: []
})
export class DUeditorConfigComponent extends DynamicComponentBase {
  static KEY = 'd-ueditor-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}
}
